import { UploadFileRequestItem } from '@features/files/types';

export const getFilesTotalSizes = (files: UploadFileRequestItem[]): number =>
  files.reduce((prevValue, currentValue) => (currentValue.upload_size || 0) + prevValue, 0);
